import { PaginationV2Links } from '@pickleballinc/react-ui';

interface BlogPaginationProps {
  currentPage: string;
  categorySlug: string;
  totalPages: number;
  subCategory?: string;
}

export const BlogPagination = ({
  currentPage,
  totalPages,
  categorySlug,
  subCategory,
}: BlogPaginationProps) => {
  const page = currentPage === 'all' ? 0 : parseInt(currentPage);

  return (
    <>
      <div className='mb-4 mt-8 size-px w-full bg-gray-200 sm:mt-4' />
      <PaginationV2Links
        totalNumberOfPages={totalPages}
        currentPage={page}
        previousLink={`/${categorySlug}/${page - 1}${subCategory ? `?subcategory=${subCategory}` : ''}`}
        nextLink={`/${categorySlug}/${page + 1}${subCategory ? `?subcategory=${subCategory}` : ''}`}
        getPageLink={(page) =>
          `/${categorySlug}/${page}${subCategory ? `?subcategory=${subCategory}` : ''}`
        }
      />
    </>
  );
};
